<div *ngIf="loading" layout="column" class="initialize" layout-align="center center" layout-fill>
  <nibras-loader [type]="loaderType.spinner"></nibras-loader>
  <h3>Launching Nibras NX...</h3>
</div>
<router-outlet> </router-outlet>
